import React, { useState } from 'react';
import { Select, Divider } from 'antd';
import { Grid, Row, Col } from 'react-flexbox-grid';
import PL01 from '../templates/PL01';
import PL02 from '../templates/PL02';
import PL03 from '../templates/PL03';
import './styles.css';

const { Option } = Select;

const SurveysTemplates = (props) => {
    const [templateSelected, setTemplateSelected] = useState('Encuesta SAT')

    const handleChange = value => {
        setTemplateSelected(value)
    }

    const sendPL01 = values => {
        console.log("sendPL01: " + JSON.stringify(values))
    }

    const sendPL02 = values => {
        console.log("sendPL02: " + JSON.stringify(values))
    }

    const sendPL03 = values => {
        console.log("sendPL03: " + JSON.stringify(values))
    }

    const surveysTemplates = {
        'Encuesta SAT': <PL01 onSubmit={sendPL01}/>,
        'Encuesta satisfaccion servicios de consultoria': <PL02 onSubmit={sendPL02}/>,
        'Encuesta satisfaccion servicios electromecanicos': <PL03 onSubmit={sendPL03}/>
    }
    
    return (
        <Grid className="surveysTemplatesCont">
            <Row center="xs">
                <Col xs={12} md={8} lg={6}>
                    <Select className="selectSurveysTemplate" defaultValue={"Encuesta SAT"} onChange={handleChange}>
                        {
                            Object.keys(surveysTemplates).map(key => <Option key={key} value={key}>{key}</Option>)
                        }
                    </Select>
                </Col>
            </Row>
            <Divider type="horizontal"/>
            {
                surveysTemplates[templateSelected]
            }
        </Grid>
    )
}

export default SurveysTemplates;